import React from 'react';

import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';
import {InputText} from 'primereact/inputtext';

class DialogCompany extends React.Component {

  constructor(props) {
    super(props);
    this.state = props.detail;

    this.inputChangeHandler = this.inputChangeHandler.bind(this);
    this.renderEditField = this.renderEditField.bind(this);
  }

  inputChangeHandler(event) {
    this.setState( { [event.target.name]  : event.target.value } );
  }

  renderEditField(field, title, keyfilter) {
    return (
      <span className="p-float-label dialog-field">
          <InputText name={field} value={this.state[field]}
           onChange={this.inputChangeHandler} keyfilter={keyfilter} />
          <label htmlFor={field}>{title}</label>
      </span>
    )
  }


  render() {
    // ensure required fields
    const { name } = this.state;
    const isValid = name.length > 0 ;

    const footer = (
      <div>
        <Button label="Save" icon="pi pi-check" disabled={!isValid}
          onClick={() => this.props.saveCompany(this.state)}/>
        <Button label="Cancel" icon="pi pi-times"
          onClick={this.props.onHide} className="p-button-secondary" />
      </div>
    );

    return (
      <div>

        <Dialog
          header="Company"
          onHide={this.props.onHide}
          visible={this.props.visible}
          className={"dialog"}
          footer={footer}>

          {this.renderEditField('name', 'Name *')}
          {this.renderEditField('deliveries_per_month', 'Livraisons par mois *', 'pint')}

        </Dialog>

      </div>
    );
  }
}

export default DialogCompany
